function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import isoWeeksInYear from "dayjs/plugin/isoWeeksInYear";
import isLeapYear from "dayjs/plugin/isLeapYear";
dayjs.extend(isoWeek);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear);
var precisionRankRecord = {
  year: 0,
  week: 1,
  "week-day": 2
};
export function defaultRenderLabel(type, data) {
  return data.toString();
}
export function generateDatePickerColumns(selected, min, max, precision, renderLabel, filter) {
  var ret = [];
  var minYear = min.getFullYear();
  var maxYear = max.getFullYear();
  var rank = precisionRankRecord[precision];
  var selectedYear = parseInt(selected[0]);
  var isInMinYear = selectedYear === minYear;
  var isInMaxYear = selectedYear === maxYear;
  var minDay = dayjs(min);
  var maxDay = dayjs(max);
  var minWeek = minDay.isoWeek();
  var maxWeek = maxDay.isoWeek();
  var minWeekday = minDay.isoWeekday();
  var maxWeekday = maxDay.isoWeekday();
  var selectedWeek = parseInt(selected[1]);
  var isInMinWeek = isInMinYear && selectedWeek === minWeek;
  var isInMaxWeek = isInMaxYear && selectedWeek === maxWeek;
  var selectedYearWeeks = dayjs("".concat(selectedYear, "-01-01")).isoWeeksInYear();
  var generateColumn = function generateColumn(from, to, weekPrecision) {
    var column = [];
    for (var i = from; i <= to; i++) {
      column.push(i);
    }
    var prefix = selected.slice(0, precisionRankRecord[weekPrecision]);
    var currentFilter = filter === null || filter === void 0 ? void 0 : filter[weekPrecision];
    if (currentFilter && typeof currentFilter === "function") {
      column = column.filter(function (i) {
        return currentFilter(i, {
          get date() {
            var stringArray = [].concat(_toConsumableArray(prefix), [i.toString()]);
            return convertStringArrayToDate(stringArray);
          }
        });
      });
    }
    return column;
  };
  if (rank >= precisionRankRecord.year) {
    var lower = minYear;
    var upper = maxYear;
    var years = generateColumn(lower, upper, "year");
    ret.push(years.map(function (v) {
      return {
        label: renderLabel("year", v),
        value: v.toString()
      };
    }));
  }
  if (rank >= precisionRankRecord.week) {
    var _lower = isInMinYear ? minWeek : 1;
    var _upper = isInMaxYear ? maxWeek : selectedYearWeeks;
    var weeks = generateColumn(_lower, _upper, "week");
    ret.push(weeks.map(function (v) {
      return {
        label: renderLabel("week", v),
        value: v.toString()
      };
    }));
  }
  if (rank >= precisionRankRecord["week-day"]) {
    var _lower2 = isInMinWeek ? minWeekday : 1;
    var _upper2 = isInMaxWeek ? maxWeekday : 7;
    var _weeks = generateColumn(_lower2, _upper2, "week-day");
    ret.push(_weeks.map(function (v) {
      return {
        label: renderLabel("week-day", v),
        value: v.toString()
      };
    }));
  }
  return ret;
}
export function convertDateToStringArray(date) {
  if (!date) return [];
  var day = dayjs(date);
  return [day.isoWeekYear().toString(), day.isoWeek().toString(), day.isoWeekday().toString()];
}
export function convertStringArrayToDate(value) {
  var _a, _b, _c;
  var yearString = (_a = value[0]) !== null && _a !== void 0 ? _a : "1900";
  var weekString = (_b = value[1]) !== null && _b !== void 0 ? _b : "1";
  var weekdayString = (_c = value[2]) !== null && _c !== void 0 ? _c : "1";
  var day = dayjs().year(parseInt(yearString)).isoWeek(parseInt(weekString)).isoWeekday(parseInt(weekdayString)).hour(0).minute(0).second(0);
  return day.toDate();
}